import "./assets/styles/main.css";
import PiedraPapelTijera from "./assets/scripts/PiedraPapelTijera";
// Elemnts
var go = document.getElementById("go");
var welcomeContainer = document.getElementById("container");
var gameConntainer = document.getElementById("game");
var resultConntainer = document.getElementById("result");
var homero = document.getElementById("homero");
var piedra = document.getElementById("piedra");
var papel = document.getElementById("papel");
var resultSpan = document.getElementById("resultSpan");
var tijera = document.getElementById("tijera");
var successSpan = document.getElementById("success");
var lossSpan = document.getElementById("loss");
var tieSpan = document.getElementById("tie");
var success = 0;
var loss = 0;
var tie = 0;
var game = new PiedraPapelTijera({
    finished: function (result) {
        // Aquí puedes poner tu codigo cuando el juego termine
    },
    result: function (result) {
        resultSpan.innerHTML = "Homero escogió " + game.getHomero(result.homero);
        if (result.validate == 2) {
            // Empate
            tie += 1;
            homero.src = "./assets/img/homero-empate.png";
            tieSpan.innerHTML = tie.toString();
        }
        else if (result.validate == 1) {
            // Ganas
            success += 1;
            homero.src = "./assets/img/homero-perdiste.png";
            successSpan.innerHTML = success.toString();
        }
        else if (result.validate == 0) {
            // Pierdes
            loss += 1;
            homero.src = "./assets/img/homero-ganaste.png";
            lossSpan.innerHTML = loss.toString();
        }
        else {
            homero.src = "./assets/img/homero-pensando.png";
        }
        console.log(result);
    },
});
go.addEventListener("click", function () {
    welcomeContainer.style.display = "none";
    gameConntainer.style.display = "block";
    resultConntainer.style.display = "block";
});
piedra.addEventListener("click", function () {
    game.play(game.getPiedra());
});
papel.addEventListener("click", function () {
    game.play(game.getPapel());
});
tijera.addEventListener("click", function () {
    game.play(game.getTijera());
});
